const medias_url = {
  twitter: "https://www.twitter.com/ondautoral",
  facebook: "https://www.facebook.com/ondautoral",
  instagram: "https://www.instagram.com/ondautoral",
  site: "https://ibdautoral.org.br",
  youtube: "https://www.youtube.com/channel/UCmikXMflVzIaQWQwZ3KuUAg",
  linkedin: "https://www.linkedin.com/company/ondautoral/",
  privatePolice: "https://ibdautoral.org.br/politica-de-privacidade/",
  contactEmail: "onda@onda.org.br"
};

export default medias_url;